import { z } from "zod";
import { AccountSchema } from "./Account"; 

export const UpdateAccountManagerSettingsRequestShema = AccountSchema.pick({
  allowExternalManagers: true,
  maxInternalManagers: true,
});

export type UpdateAccountManagerSettingsRequest = z.infer<typeof UpdateAccountManagerSettingsRequestShema>;